import { Navigate } from 'react-router';

import type { RootLoaderType } from '../data-access';
import { useTypedRouteLoaderData } from '../hooks';

export const NotFound = () => {
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');

  return <Navigate to={storeId ? `/stores/${storeId}` : '/'} />;
};
